<style lang="scss">
  .switch-with-label {
    font-size: 0.875rem;

    &__help-icon {
      @media (max-width: 600px) {
        // 22px beside the 14px label
        font-size: calc(22em / 14);
      }
    }

    &__switch {
      &.mobile-collapse {
        @media (max-width: 600px) {
          display: block;
          margin: auto;
        }
      }
    }
  }
</style>
<template>
    <div class="inline-block switch-with-label">
        <vue-switch
                :name="name"
                :model-value="modelValue"
                :disabled="disabled"
                :small="small"
                :aria-label="label"
                class="vertical-middle switch-with-label__switch"
                @update:model-value="on_input"
                :class="{'mobile-collapse':collapseOnMobile}"
                ref="switch"
        ></vue-switch>
        <span class="vertical-middle"><slot name="label">{{ label }}</slot>

        </span>
        <i v-if="helpLink"
           class="fal fa-question-circle switch-with-label__help-icon vertical-middle"
           role="link"
           :class="disabled ? 'cursor-not-allowed' : 'pointer'"
           tabindex="0"
           @keyup.enter="openHelpLink"
           @click="openHelpLink"></i>
        <i v-else-if="helpText"
           class="fal fa-question-circle switch-with-label__help-icon pointer vertical-middle"
           v-tooltip.hover="helpText"
           :trigger="isMobile?'outside-click':'hover'"
           :show-delay="400"
           :hide-delay="800"></i>
    </div>
</template>
<script>
    import Switch from './Switch.vue';
    import MobileDetect from 'mobile-detect';

    export default {
        emits: ['changed', 'update:modelValue'],
        data() {
            return {};
        },
        computed: {
            isMobile() {
                return new MobileDetect(window.navigator.userAgent).mobile();
            }
        },
        components: {
            'vue-switch': Switch
        },
        props: {
            collapseOnMobile: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            helpText: {
                type: String,
                required: false
            },
            helpLink: {
                type: String,
                required: false
            },
            disabled: {
                type: Boolean,
                required: false
            },
            small: {
                type: Boolean,
                required: false,
                default: false
            },
            modelValue: Boolean
        },
        methods: {
            on_input(val) {
                this.$emit('update:modelValue', Boolean(val));
                this.$emit('changed', Boolean(val));
            },
            focus() {
                this.$refs.switch?.focus();
            },
            openHelpLink() {
                if (this.disabled) return;
                window.open(this.helpLink, '_blank');
            }
        }
    };
</script>
